function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  $(".Details-HeaderMenu-Container").mouseover(function(){
    $(this).attr("open", "open");
    $(this).find("summary").attr("aria-expanded", "true");
  });
  
  $(".Details-HeaderMenu-Container").mouseout(function(){
    $(this).removeAttr("open", "open");
    $(this).find("summary").attr("aria-expanded", "false");
  });
  

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }
 
  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;
  
    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    var checkedoption = $(this).find('.product-form__input-2 input[type="radio"]:checked').val();
    if($('.product-variant-metafield').length){
      $('.product-variant-metafield').hide();
      $('.product-variant-metafield[data-variantname="' + checkedoption + '"]').show();
    }
     this.swiper = new Swiper(".main-product-slider-thumb", {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true, 
       observer: true,
    	observeParents: true,
      direction: "horizontal",
      breakpoints: {
        500: {
          spaceBetween: 10,
          slidesPerView: 5,
          direction: "horizontal",
        },
        769: {
          spaceBetween: 10,
          slidesPerView: 6,
          direction: "horizontal",
        },
        1024: {
        slidesPerView: 'auto',
        direction: "vertical",
        },
      },
    });
    this.swiper2 = new Swiper(".main-product-slider", {
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: this.swiper,
      },
    });

   if($('.main-product-bundle-container').length > 0){
      var variantdiscount = $('.variant-selects-bundle-tag').find('.label-checked').find('.variant-label-discount:visible').data('discount');
      if(variantdiscount){
        $('.discounted_price_count').html(variantdiscount);
        $('.discounted_badge').show();
      }else{
        $('.discounted_badge').hide();
      }
      
      var $scope = $('.product-form__input-2');
      var selected = $scope.find('label.label-checked').map(function () {
        var val = $(this).attr('data-value') || '';
        var forId = $(this).attr('for') || '';
        var $input = forId ? $scope.find('#' + forId) : $();

        return {
          value: val,
          subscriptionserving: $input.attr('data-subscriptionserving') || '',
          serving: $input.attr('data-serving') || ''
        };
      }).get();

      var pick = selected.find(function (x) { return x.subscriptionserving || x.serving; }) || selected[0] || {};
      $('.per-serving-price').html((pick.serving || '') + ' servings | From ' + (pick.subscriptionserving || '') + ' a day');

    }  
  }

  onVariantChange(event) {
    
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateDynamicSubscriptionBadge();
      this.updateShareUrl();
    }

  }


 updateDynamicSubscriptionBadge() {
  console.log('updateDynamicSubscriptionBadge');
   // Get selected pack from checked radio option2 (1-Pack, 2-Pack, 3-Pack)
  var selectedPack = $('.product-form__input-2 input[type="radio"]:checked').val();
  if (!selectedPack) return;

  // Get variant plans JSON
  var variantPlansEl = document.querySelector('.variant-plans-json');
  if (!variantPlansEl) return;

  var variantPlans;
  try { variantPlans = JSON.parse(variantPlansEl.textContent); }
  catch(e) { return; }

  // Find variant where option2 matches selected pack (e.g. "1-Pack", "2-Pack", "3-Pack")
  var matchedVariant = variantPlans.find(function(v) {
    return v.option2 === selectedPack;
  });
  if (!matchedVariant || !matchedVariant.plans.length) return;

  // Get the plan (only one plan per variant)
  var plan = matchedVariant.plans[0];
  var discountOnly = plan.discount_type === 'percentage'
    ? plan.discount + '%'
    : '£' + (plan.discount / 100).toFixed(2);

  // 1. Update header title
  $('.susbscription-main-container-title').html(
    'Pick a Delivery Option:&nbsp;&nbsp;Subscribe & Save ' + discountOnly
  );

  // 2. Update badge
  $('.dynamic-discount-badge').text('Save ' + discountOnly);

  // 3. Update subcontent — replace any XX% in block.settings.subcontent
  var $allItems = $('.dynamic-subcontent-item');
  if ($allItems.length) {
    $allItems.hide();
    var $matched = $allItems.filter(function() {
      return $(this).data('plan-name') === plan.name;
    });
    if ($matched.length) {
      $matched.first().show();
    } else {
      $allItems.first().show();
    }
  }

  console.log('Pack:', selectedPack, '| Plan:', plan.name, '| Discount:', discountOnly);
}

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
        
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
      
      if($('.main-product-bundle-container').length > 0){
        var variantdiscount = $('.variant-selects-bundle-tag').find('label[data-value="' + value + '"]').find('.variant-label-discount:visible').data('discount');
        if(variantdiscount){
          $('.discounted_price_count').html(variantdiscount);
          $('.discounted_badge').show();
        }else{
          $('.discounted_badge').hide();
        }
      }
    }

    if ($('.product-price-sticky').length) {
        setTimeout(function() {
         var priceinfo = $('.product-price-container').html();
         $('.product-price-sticky').html(priceinfo);
          
        }, 1200);
      }

    if($('.product-variant-metafield').length){
      $('.product-variant-metafield').hide();
      $('.product-variant-metafield[data-variantname="' + value + '"]').show();
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );
    $('.product__media-wrapper .main-product-slider .swiper-slide').eq(0).find('.image-magnify-none').attr('src',this.currentVariant.featured_media.preview_image.src);
    $('.product__media-wrapper .main-product-slider .swiper-slide').eq(0).find('.image-magnify-none').attr('srcset',this.currentVariant.featured_media.preview_image.src);
    $('.product__media-wrapper .thumbnail-container .swiper-slide').eq(0).find('.image-magnify-none').attr('src',this.currentVariant.featured_media.preview_image.src);
    $('.product__media-wrapper .thumbnail-container .swiper-slide').eq(0).find('.image-magnify-none').attr('srcset',this.currentVariant.featured_media.preview_image.src);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
    var imageHtml = $(".productinfo_icon_box").html();
     $(".desktop-view").find(".productinfo_icon_box").remove();
    $(".desktop-view").find(".product__media-item").removeClass("frist_media_box")
    $(".desktop-view").find(".product__media-item").eq(0).addClass("frist_media_box")
    $(".desktop-view").find(".product__media-item").eq(0).append(`<div class="productinfo_icon_box" bis_skin_checked="1">${imageHtml}</div>`)
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
  
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {


        

        if (this.currentVariant.id !== requestedVariantId) return;

        var this2 = this.currentVariant.option2;
        
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        console.log("kljasdlasdsa" + this.dataset.section);      
        
          const subscriptionSource = html.getElementById(
            `susbscription-main-container-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const subscriptionDestination = document.getElementById(
            `susbscription-main-container-${this.dataset.section}`
          );
          var seleplan = $(subscriptionDestination).find('.susbscription-subscribe-save-value').find('.selected-text-label').html().trim();
          var subval = $('.susbscription-main-container input[name="product-susbscription"]:checked').val();
         
          // if (subscriptionSource && subscriptionDestination) subscriptionDestination.innerHTML = subscriptionSource.innerHTML;
          if (subscriptionSource && subscriptionDestination) {
  subscriptionDestination.innerHTML = subscriptionSource.innerHTML;
  this.updateDynamicSubscriptionBadge();
}
          // Re-read the discount value directly from the newly rendered subscription block
          var newDiscount = $(subscriptionDestination).find('.susbscription-subscribe-save-info .selected-text-label').text().trim();
          var newDiscountBadge = $(subscriptionDestination).find('.subscribe-save-title .subscription-save-title2').text().trim();
          if (newDiscountBadge) {
            $('.discounted_price_count').html(newDiscountBadge);
            $('.discounted_badge').show();
          } else {
            // fallback: read from display_discount rendered in the title
            var renderedTitle = $(subscriptionDestination).find('.susbscription-main-container-title').text();
          var discountMatch = renderedTitle.match(/Save\s+(\d+%)/i);
          if (discountMatch) {
            $('.discounted_price_count').html(discountMatch[1]);
            $('.discounted_badge').show();
          } else {
            $('.discounted_badge').hide();
          }
          }
          
          $('.susbscription-subscribe-save-value').unbind().click(function(){
            $('.susbscription-subscribe-dropdown').toggleClass('active-subscription-save');
          });
         
          $('.subscription-subscribe-label').unbind().click(function(){
            var selectedvalue = $(this).text();
            $(this).parents('.susbscription-subscribe-save-info').find('.selected-text-label').text(selectedvalue);
             $('.susbscription-subscribe-dropdown').removeClass('active-subscription-save');
          });
         
           $('.susbscription-main-container input[name="product-susbscription"]').change(function(){
            if($('.susbscription-main-container input[name="product-susbscription"]:checked').val() == 'one-time-subscription'){
              $('.susbscription-main-container').find('input[name="selling_plan"]').attr('disabled',true);
              $('.variant-label-subscribe').hide();
              $('.variant-label-one-time').show();
              var productprice = $('.one-time-purchase-price').text().trim();
              var productcprice = $('.one-time-purchase-compare-price').text().trim();
              $('.product_price_regular_main').text(productprice);
              $('.product_compare_price_regular').text(productcprice);
              var variantdiscount = $('.variant-selects-bundle-tag').find('label[data-value="' + this2 + '"]').find('.variant-label-discount:visible').data('discount');
              if(variantdiscount){
                $('.discounted_price_count').html(variantdiscount);
                $('.discounted_badge').show();
              }else{
                $('.discounted_badge').hide();
              }
              var variantonetimeservings = $('.variant-selects-bundle-tag').find('input[value="' + this2 + '"]').attr('data-onetimeserving');
              var variantsubservings = $('.variant-selects-bundle-tag').find('input[value="' + this2 + '"]').attr('data-subscriptionserving');
              var variantserv = $('.variant-selects-bundle-tag').find('input[value="' + this2 + '"]').attr('data-serving');
              $('.per-serving-price').html(variantserv +' servings'+' | From '+variantonetimeservings + ' a day'); 
              
            }else{ 
              $('.susbscription-main-container').find('.subscription-subscribe-label:visible').find('input[name="selling_plan"]').removeAttr('disabled'); 
              $('.variant-label-subscribe').show();
              $('.variant-label-one-time').hide();
              var productprice = $('.susbscribe-save-price').text().trim();
              var productcprice = $('.susbscribe-save-cprice').text().trim();
              $('.product_price_regular_main').text(productprice);
              $('.product_compare_price_regular').text(productcprice);
              var variantdiscount = $('.variant-selects-bundle-tag').find('label[data-value="' + this2 + '"]').find('.variant-label-discount:visible').data('discount');
              if(variantdiscount){
                $('.discounted_price_count').html(variantdiscount);
                $('.discounted_badge').show();
              }else{
                $('.discounted_badge').hide();
              }
              var variantonetimeservings = $('.variant-selects-bundle-tag').find('input[value="' + this2 + '"]').attr('data-onetimeserving');
              var variantsubservings = $('.variant-selects-bundle-tag').find('input[value="' + this2 + '"]').attr('data-subscriptionserving');
              var variantserv = $('.variant-selects-bundle-tag').find('input[value="' + this2 + '"]').attr('data-serving');
              $('.per-serving-price').html(variantserv +' servings'+' | From '+variantsubservings + ' a day'); 
            } 
          })
          if(subval == 'one-time-subscription'){
            $('.one-time-purchase-label').click();
          }
           
          $('.subscription-subscribe-label[data-name="'+seleplan+'"]').click();

          $('.susbscription-subscribe-save-value').unbind().click(function (event) {
            event.stopPropagation();
            $('.susbscription-subscribe-dropdown').toggleClass('active-subscription-save');
          });
        
          $(document).click(function () {
            $('.susbscription-subscribe-dropdown').removeClass('active-subscription-save');
          });


        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
      
        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );


        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });

       

       if(subval=='one-time-subscription'){
          var productprice = $('.one-time-purchase-price').text().trim();
          var productcprice = $('.one-time-purchase-compare-price').text().trim();
          $('.product_price_regular_main').text(productprice);
          $('.product_compare_price_regular').text(productcprice);
          var variantdiscount = $('.variant-selects-bundle-tag').find('label[data-value="' + this2 + '"]').find('.variant-label-discount:visible').data('discount');
          console.log("sdasd=="+variantdiscount);
          if(variantdiscount){
            $('.discounted_price_count').html(variantdiscount);
            $('.discounted_badge').show();
          }else{
            $('.discounted_badge').hide();
          }

          var variantonetimeservings = $('.variant-selects-bundle-tag').find('input[value="' + this2 + '"]').attr('data-onetimeserving');
          var variantsubservings = $('.variant-selects-bundle-tag').find('input[value="' + this2 + '"]').attr('data-subscriptionserving');
          $('.subscribe-servings-info').html(variantsubservings+' / Serving');
          $('.onetime-servings-info').html(variantonetimeservings+' / Serving');
          var variantserv = $('.variant-selects-bundle-tag').find('input[value="' + this2 + '"]').attr('data-serving');
          $('.per-serving-price').html(variantserv +' servings'+' | From '+variantonetimeservings + ' a day');       
 
        }else{
           console.log("subscriptionsubval=="+subval);
          var productprice = $('.susbscribe-save-price').text().trim();
          var productcprice = $('.susbscribe-save-cprice').text().trim();
          $('.product_price_regular_main').text(productprice);
          $('.product_compare_price_regular').text(productcprice);
          var variantdiscount = $('.variant-selects-bundle-tag').find('label[data-value="' + this2 + '"]').find('.variant-label-discount:visible').data('discount');
          console.log("sdasd=="+variantdiscount);
          if(variantdiscount){
            $('.discounted_price_count').html(variantdiscount);
            $('.discounted_badge').show();
          }else{
            $('.discounted_badge').hide();
          }

          var variantonetimeservings = $('.variant-selects-bundle-tag').find('input[value="' + this2 + '"]').attr('data-onetimeserving');
          var variantsubservings = $('.variant-selects-bundle-tag').find('input[value="' + this2 + '"]').attr('data-subscriptionserving');
          $('.subscribe-servings-info').html(variantsubservings+' / Serving');
          $('.onetime-servings-info').html(variantonetimeservings+' / Serving');
          var variantserv = $('.variant-selects-bundle-tag').find('input[value="' + this2 + '"]').attr('data-serving');
          $('.per-serving-price').html(variantserv + ' servings' + ' | From ' + variantsubservings + ' a day');      
        }
      });   
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }
 
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
 
          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


class imagewithfaq extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".faq-questions-" + this.getAttribute("data-sectionid")).click(
        function (e) {
          e.preventDefault();
          let $this = $(this);
          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);
            $this.parent().removeClass("active");
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });
          } else {
            $(this).parent().parents(".faq-accordion-wrapper")
              .find(".faq-answers")
              .removeClass("show");
            $(this).parent().parents(".faq-accordion-wrapper").find(".faq-answers").slideUp(350);
            $(this).parent().parents(".faq-accordion-wrapper").removeClass("active");
            $(this).parent().parents(".faq-accordion-wrapper")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $(this).parent().parents(".faq-accordion-wrapper")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });
            $this.next().toggleClass("show");
            $this.next().slideToggle(350);
            $this.parent().toggleClass("active");
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "none" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "flex" });
          }
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("image-with-faq", imagewithfaq);


class customproductinfo extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
     
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-product-info", customproductinfo);

class CustomUpsellProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

       $(this).css({"opacity":"1"});

       var swiper = new Swiper(".upsell-products-slider", {
        slidesPerView: 2,
        spaceBetween: 20,
        navigation: {
          nextEl: ".upsell-next",
          prevEl: ".upsell-prev",
        },
        breakpoints: {
        740: {
          slidesPerView:2,
          spaceBetween: 20,
        },
        1220: {
          slidesPerView:1.8,
          spaceBetween: 20,
        },
        1420: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
      });

      
      $(".custom-upsell--var-size").change(function () {
        var sizevalue = $(this).val();
        var packvalue = $(this)
            .parents(".custom-upsell-products-container")
            .find(".custom-upsell-var-pack-size")
            .val();

        $(".error-var-response").css({ display: "none" });

        $(this)
          .parents(".custom_main_upsell_card_product")
          .find(".upsellvarselect option")
          .each(function (i) {
            
            var varsize = $(this).data("option1");
            var varpacksize = $(this).data("option2");

            if (varsize != "" && varpacksize != "") {
               
              if (varsize == sizevalue && varpacksize == packvalue) {
                var varname = packvalue + " / " + sizevalue;
                var productvarid = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .val();
                var productvaridavailable = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .attr("data-available");

                $(this)
                  .parents(".custom_main_upsell_card_product")
                  .find('.upsell-product-form').find('.upsell-product-variant-id').val(productvarid);
       
                if (productvaridavailable == "true") {
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn")
                    .removeAttr("disabled");
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn .custom-atc-text")
                    .html(
                      'Add to Cart'
                    );
                } else {
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn")
                    .attr("disabled", true);
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn .custom-atc-text")
                    .text("Sold Out");
                }
              }
            } else if (varsize == "") {
              if (varpacksize == packvalue) {
                var varname = packvalue;
                var productvarid = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .val();
                var productvaridavailable = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .attr("data-available");

                $(this)
                  .parents(".custom_main_upsell_card_product")
                  .find('.upsell-product-form').find('.upsell-product-variant-id').val(productvarid);

                if (productvaridavailable == "true") {
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn")
                    .removeAttr("disabled");
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn .custom-atc-text")
                    .html(
                      'Add to Cart'
                    );
                } else {
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn")
                    .attr("disabled", true);
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn .custom-atc-text")
                    .text("Sold Out");
                }
              }
            } else if (varpacksize == "") {
              if (varsize == sizevalue) {
                var varname = varsize;
                var productvarid = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .val();
                var productvaridavailable = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .attr("data-available");

                $(this)
                  .parents(".custom_main_upsell_card_product")
                  .find('.upsell-product-form').find('.upsell-product-variant-id').val(productvarid);

                if (productvaridavailable == "true") {
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn")
                    .removeAttr("disabled");
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn .custom-atc-text")
                    .html(
                      'Add to Cart'
                    );
                } else {
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn")
                    .attr("disabled", true);
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn .custom-atc-text")
                    .text("Sold Out");
                }
              }
            }
          });
      });

      $(".custom-upsell-var-pack-size").change(function () {
        var sizevalue = $(this).val();
        var packvalue = $(this)
            .parents(".custom-upsell-products-container")
            .find(".custom-upsell--var-size")
            .val();

        $(".error-var-response").css({ display: "none" });

        $(this)
          .parents(".custom_main_upsell_card_product")
          .find(".upsellvarselect option")
          .each(function (i) {
            
            var varsize = $(this).data("option2");
            var varpacksize = $(this).data("option1");

            if (varsize != "" && varpacksize != "") {
               
              if (varsize == sizevalue && varpacksize == packvalue) {
                var varname = packvalue + " / " + sizevalue;
                var productvarid = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .val();
                var productvaridavailable = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .attr("data-available");

                $(this)
                  .parents(".custom_main_upsell_card_product")
                  .find('.upsell-product-form').find('.upsell-product-variant-id').val(productvarid);
       
                if (productvaridavailable == "true") {
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn")
                    .removeAttr("disabled");
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn .custom-atc-text")
                    .html(
                      'Add to Cart'
                    );
                } else {
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn")
                    .attr("disabled", true);
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn .custom-atc-text")
                    .text("Sold Out");
                }
              }
            } else if (varsize == "") {
              if (varpacksize == packvalue) {
                var varname = packvalue;
                var productvarid = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .val();
                var productvaridavailable = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .attr("data-available");

                $(this)
                  .parents(".custom_main_upsell_card_product")
                  .find('.upsell-product-form').find('.upsell-product-variant-id').val(productvarid);

                if (productvaridavailable == "true") {
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn")
                    .removeAttr("disabled");
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn .custom-atc-text")
                    .html(
                      'Add to Cart'
                    );
                } else {
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn")
                    .attr("disabled", true);
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn .custom-atc-text")
                    .text("Sold Out");
                }
              }
            } else if (varpacksize == "") {
              if (varsize == sizevalue) {
                var varname = varsize;
                var productvarid = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .val();
                var productvaridavailable = $(this)
                  .filter("[data-copvartitle='" + varname + "']")
                  .attr("data-available");

                $(this)
                  .parents(".custom_main_upsell_card_product")
                  .find('.upsell-product-form').find('.upsell-product-variant-id').val(productvarid);

                if (productvaridavailable == "true") {
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn")
                    .removeAttr("disabled");
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn .custom-atc-text")
                    .html(
                      'Add to Cart'
                    );
                } else {
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn")
                    .attr("disabled", true);
                  $(this)
                    .parents(".custom_main_upsell_card_product")
                    .find(".custom-addtocart-upsell-btn .custom-atc-text")
                    .text("Sold Out");
                }
              }
            }
          });
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-upsell-products", CustomUpsellProducts);


class FaqSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".faq-questions-" + this.getAttribute("data-sectionid")).click(
        function (e) {
          e.preventDefault();
          let $this = $(this);
          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);
            $this.parent().removeClass("active");
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });
          } else {
            $(".faq-accordion-wrapper")
              .find(".faq-answers")
              .removeClass("show");
            $(".faq-accordion-wrapper").find(".faq-answers").slideUp(350);
            $(".faq-accordion-wrapper").removeClass("active");
            $(".faq-accordion-wrapper")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $(".faq-accordion-wrapper")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });
            $this.next().toggleClass("show");
            $this.next().slideToggle(350);
            $this.parent().toggleClass("active");
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "none" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "flex" });
          }
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("faq-section", FaqSection);

class CustomerReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

       $(this).css({"opacity":"1"});
       var autoplay = $(this).data('autoplay');
       var loop = $(this).data('loop');
       var swiper = new Swiper(".custom-review-slider-" + this.getAttribute("data-sectionid"), {
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop:loop,
        autoplay: {
          enabled: autoplay,
          delay: 3000,
          disableOnInteraction: false,
        }, 
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          740: {
            slidesPerView:1.2,
            spaceBetween: 20,
          },
          990: {
            slidesPerView:2.8,
            spaceBetween: 20,
          },
          1400: {
            slidesPerView:4.2,
            spaceBetween: 20,
          },
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("customer-reviews", CustomerReviews);


$('.susbscription-main-container input[name="product-susbscription"]').change(function(){
  if($('.susbscription-main-container input[name="product-susbscription"]:checked').val() == 'one-time-subscription'){
    $('.susbscription-main-container').find('input[name="selling_plan"]').attr('disabled',true);
    $('.variant-label-subscribe').hide();
    $('.variant-label-one-time').show();
    var productprice = $('.one-time-purchase-price').text().trim();
    var productcprice = $('.one-time-purchase-compare-price').text().trim();
    $('.product_price_regular_main').text(productprice);
    $('.product_compare_price_regular').text(productcprice);
    var variantdiscount = $('.variant-selects-bundle-tag').find('.label-checked').find('.variant-label-discount:visible').data('discount');
    if(variantdiscount){
      $('.discounted_price_count').html(variantdiscount);
      $('.discounted_badge').show();
    }else{
      $('.discounted_badge').hide();
    }
  }else{
    $('.susbscription-main-container').find('.subscription-subscribe-label:visible').find('input[name="selling_plan"]').removeAttr('disabled'); 
    $('.variant-label-subscribe').show();
    $('.variant-label-one-time').hide();
    var productprice = $('.susbscribe-save-price').text().trim();
    var productcprice = $('.susbscribe-save-cprice').text().trim();
    $('.product_price_regular_main').text(productprice);
    $('.product_compare_price_regular').text(productcprice);
      var variantdiscount = $('.variant-selects-bundle-tag').find('.label-checked').find('.variant-label-discount:visible').data('discount');
      if(variantdiscount){
        $('.discounted_price_count').html(variantdiscount);
        $('.discounted_badge').show();
      }else{
        $('.discounted_badge').hide();
      }
  } 
});



 
var swiper = new Swiper(".footer-image-slider", {
  slidesPerView: 2.5,
  spaceBetween: 20,
  grabCursor: true,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4.5,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 6.5,
      spaceBetween: 20,
    },
  },
}); 

 
// Footer toogle 
 
document.addEventListener("DOMContentLoaded", function () {

  const plusIcon = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  </svg>`;

  const minusIcon = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 12H18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

  function initFooterAccordion() {
    const isMobile = window.innerWidth <= 768;

    document.querySelectorAll(".footer-block--menu").forEach(function(block) {
      const heading = block.querySelector(".footer-block__heading");
      const content = block.querySelector(".footer-block__details-content");
      if (!heading || !content) return;

      const existingWrapper = block.querySelector(".heading-block");

      /* ---------- MOBILE ---------- */
      if (isMobile) {

        if (!existingWrapper) {
          const wrapper = document.createElement("div");
          wrapper.className = "heading-block";

          const icon = document.createElement("span");
          icon.className = "accordion-icon";
          icon.innerHTML = plusIcon;

          heading.parentNode.insertBefore(wrapper, heading);
          wrapper.appendChild(heading);
          wrapper.appendChild(icon);

          content.style.display = "none";

          wrapper.addEventListener("click", function () {
            const isOpen = content.style.display === "block";

            // close others
            document.querySelectorAll(".footer-block--menu").forEach(function(other) {
              const otherContent = other.querySelector(".footer-block__details-content");
              const otherIcon = other.querySelector(".accordion-icon");
              if (otherContent) otherContent.style.display = "none";
              if (otherIcon) otherIcon.innerHTML = plusIcon;
            });

            if (!isOpen) {
              content.style.display = "block";
              icon.innerHTML = minusIcon;
            } else {
              content.style.display = "none";
              icon.innerHTML = plusIcon;
            }
          });
        }

      }

      /* ---------- DESKTOP ---------- */
      else {
        if (existingWrapper) {
          block.insertBefore(heading, existingWrapper);
          existingWrapper.remove();
          content.style.display = "";
        }
      }

    });
  }

  initFooterAccordion();

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initFooterAccordion, 200);
  });

});
 
// End Footer toogle 

 